import { css } from '@linaria/core';

export const row = css`
  contain: strict;
  contain: size layout style paint;
  display: grid;
  grid-template-rows: var(--row-height);
  grid-template-columns: var(--template-columns);
  position: absolute;
  left: 0;
  width: var(--row-width);
  height: var(--row-height); // needed on Firefox
  line-height: var(--row-height);
  background-color: var(--background-color);
  color: var(--color);
`;

export const rowCellShowMenuClassname = css`
  &.rdg-row {
    contain: none;
  }
`;

export const rowClassname = `rdg-row ${row}`;


export const rowIsAddClassname = css`
    &.rdg-row {
      background-color: var(--table-new-color);
    }
`;

export const rowIsDeleteClassname = css`
    &.rdg-row {
      background-color: var(--table-delete-color);
    }
`;

export const rowSelected = css`
    &.rdg-row-selected.rdg-row {
      background-color: var(--row-selected-background-color);
      color: var(--selected-color);
      .rdg-cell {
        background-color: var(--row-selected-cell-background-color);
        color: var(--selected-color);
      }
    }
`;

export const rowSelectedClassname = `rdg-row-selected ${rowSelected}`;

const summaryRow = css`
  position: sticky;
  z-index: 3;
  grid-template-rows: var(--summary-row-height);
  height: var(--summary-row-height); // needed on Firefox
  line-height: var(--summary-row-height);
`;

export const lastSummaryRowClassname = css`
    .rdg-cell {
      border-bottom-width: 2px;
    }
`;

export const summaryRowClassname = `rdg-summary-row ${summaryRow}`;


export const dropOverRowClassName = css`
    &:before {
        content: '';
        position: absolute;
        width: calc(100%);
        height: 2px;
        background: var(--row-selected-background-color);
        top: 0px;
        z-index: 1;
    }
`;

export const dragingRowClassName = css`
  opacity: 0.6;
`;


export const rdgDragPreviewClassname = css`
position: absolute;
left: 0px;
height: 100%;
width: 100%;
pointer-events: none;
`;

export const toolsOverlayClassname = css`
    .ant-popover-arrow {
      display: none;
    }
    .ant-popover-inner-content {
      padding: 0px;
      padding-left: 10px;
    }
    .ant-popover-inner {
      background-color: transparent;
      box-shadow: unset;
    }
    &.ant-popover {
      padding-top: 0px;
    }
`;


export const rowMainSelectClassname = css`
    &.rdg-row > .rdg-cell div:nth-child(1)  {
      font-weight: bold;
    }
`;